<template>
  <div class="card p-4">
    <div class="card-header">
      <h4 class="card-title">Informasi Konfirmasi Pembayaran</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-4">
          <i class="text-primary fas fa-money-check"></i>
          <span class="title"> No Rekening : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.accountNumber }}
          </p>
          <i class="text-primary fas fa-sticky-note"></i>
          <span class="title"> Memo : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.memo }}
          </p>
        </div>
        <div class="col-sm-4">
          <i class="text-primary fas fa-money-check"></i>
          <span class="title"> No Referensi Bank : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.referenceNumber }}
          </p>
          <i class="text-primary fas fa-sticky-note"></i>
          <span class="title"> Memo : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.memo }}
          </p>
        </div>
        <div class="col-sm-4">
          <i class="text-primary fas fa-user"></i>
          <span class="title"> Atas Nama : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.asName }}
          </p>
          <i class="text-primary fas fa-money-bill-wave"></i>
          <span class="title"> Total Bayar : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.totalPaymentCurrencyFormat }}
          </p>
        </div>
        <div class="col-sm-4">
          <i class="text-primary fas fa-clock"></i>
          <span class="title"> Tgl Bayar : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.datePayment }}
          </p>
          <i class="text-primary fas fa-info-circle"></i>
          <span class="title"> Status : </span>
          <content-placeholders-text :lines="1" />
          <p>
            {{ sectionConfirmPayment.status }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sectionConfirmPayment: {},
  },
};
</script>